'use client'

import { motion } from 'framer-motion'
import { Link } from '@/routing'

export const MotionLink = motion.create(Link)
